import React, { useEffect, useState } from "react";
import "./WinnersHome.css";
import smallarrow from "../../Images/Vector (3).png";
import heart from "../../Images/Vector (4).png";
import logo from "../../Images/Group 1171279193.png";
import star from "../../Images/star 1.png";
import location from "../../Images/Vector (5).png";
import { useNavigate } from "react-router-dom";
import uparrow from "../../Images/Group (2).png";
import img from "../../Images/Rectangle 20.png";
import HomeService from "../../Services/HomeService";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const WinnersPropertyDealers = () => {
  const [userId, setUserId] = useState("");
  const [advertisement, setAdvertisement] = useState([]);
  const navigate = useNavigate();
  const [isClicked, setIsClicked] = useState(false);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
   responsive: [
      {
        breakpoint: 1199, 
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 699, 
        settings: {
          slidesToShow: 1,
        },
      },
      
    ],
  };
  //   const handleClick = async (propertyId) => {
  //     try {
  //       const data = {
  //         userId: userId,
  //         propertyId: propertyId,
  //       };

  //       const res = await HomeService.addToWishList(data);
  //       console.log("res", res);

  //       if (res?.status) {
  //         if (isClicked === true) {
  //           setIsClicked(false);
  //         }
  //         if (isClicked === false) {
  //           setIsClicked(true);
  //         }
  //         // fetchAllProperty({ userId });
  //       } else {
  //         console.error("Failed to add property to wishlist:", res?.message);
  //       }
  //     } catch (error) {
  //       // if (error?.status) {
  //       //     console.log('favourite property wishlist res:', error);
  //       //     if (isClicked === true) {
  //       //         setIsClicked(false)
  //       //     }
  //       //     if (isClicked === false) {
  //       //         setIsClicked(true)
  //       //     }
  //       //     fetchAllProperty({ userId })
  //       // }
  //       console.error("Error adding property to wishlist:", error);
  //     }
  //   };

  const fetchAllAdvertisement = async () => {
    try {
      const res = await HomeService.getAllAdvertisement();
      if (res?.status) {
        setAdvertisement(res.data);
      } else {
        console.error("Failed to fetch advertisements:", res?.message);
      }
    } catch (error) {
      console.error("Error fetching advertisements:", error);
    }
  };

  const fetchLoginProfile = async () => {
    const response = await HomeService.getLoginProfile();
    // console.log("this is login profile response", response);

    if (response?.status) {
      setUserId(response?.data?._id);
    }
  };

  const handleNavigateDealer = (dealerDetails) => {
    navigate("/communitylist", { state: { dealerDetails,
      showInnerState: false 
     } });
  };

  useEffect(() => {
    fetchLoginProfile();
  }, []);
  useEffect(() => {
    fetchAllAdvertisement();
    // console.log("all advertisement data", advertisement);
  }, []);
  return (
    <>
      <div className="property_dealers_wrapper_div">
        <div className="property_dealers_div">
          <div className="property_dealers_head">
            <h1 className="search_cities_head">Property Dealers Nearby </h1>
            {/* <button onClick={() => navigate("/communitylist")}>
              View All Dealers
              <img src={smallarrow}></img>
            </button> */}
          </div>
          
          <div className="mt-4">
          <Slider {...settings}>
          {advertisement.map((e, i) => {
            return (
              <>
              
                <div key={e._id || i} className="property_div">
                  <div className="property_img">
                    <img className="property_img2" src={e.image} />
                    <div className="like_div_wrapper">
                      {/* <div
                        className={`like_heart_img_div ${
                          e?.isFavorite ? "clicked" : ""
                        }`}
                        onClick={() => {
                          handleClick(e._id);
                        }}
                      >
                        <img src={heart}></img>
                      </div> */}
                      <div className="property_logo_div_wrapper">
                        <img src={e.logo}></img>
                      </div>
                    </div>
                  </div>
                  <div className="property_details_wrapper">
                    <div className="property_details_head">
                      <p className="property_name_para">{e.advertiseName}</p>
                    </div>

                    <div className="property_details_location">
                      <i class="fa-solid fa-location-dot location"></i>
                      <p>{e.majorLocality}</p>
                    </div>
                    <div className="rating_div_wrapper">
                      <div className="rating_div">
                        <img src={star}></img>
                        <p>3.6</p>
                      </div>
                      <div
                        className="up_arrow_div"
                        onClick={() => {
                          handleNavigateDealer(e);
                        }}
                      >
                        <img src={uparrow} />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
          </Slider>

          

          {/* </Slider> */}
        </div>
              

        </div>
      </div>
    </>
  );
};

export default WinnersPropertyDealers;
